import {Directive} from '@angular/core';

@Directive({
  selector: '[icon]'
})
export class IconDirective {

  constructor() {
  }
}
